// core
import { Component, Input } from '@angular/core';

// services
import { RaptorStepService } from '../../../services/raptor-step.service';
@Component({
  selector: 'open-raptor-sidebar-section-default',
  templateUrl: './raptor-sidebar-section-default.component.html',
  styleUrls: ['./raptor-sidebar-section-default.component.scss']
})
export class RaptorSidebarSectionDefaultComponent {
  @Input() section: any;
  @Input() form: any;
  @Input() collapsed!: boolean;

  constructor(public raptorStepService: RaptorStepService) { }

}
